import * as angular from 'angular';

angular
  .module('screeningcanvas')
  .filter('formatEstimatePriceUnitSuffix', function () {
    return function (input) {
      switch (input) {
        case 'ONCE': return '';
        case 'ITEM': return '/pz';
        case 'YEAR': return '/anno';
        case 'MONTH': return '/mese';
        case 'WEEK': return '/settimana';
        case 'HOUR': return '/ora';
        default: return '';
      }
    };
  });
